function updatePrices(scope, billingCycle) {
  const yearly = billingCycle === "yearly";

  scope.querySelectorAll("[data-monthly-price]").forEach((price) => {
    price.textContent = yearly
      ? price.dataset.yearlyPrice
      : price.dataset.monthlyPrice;
  });

  scope.querySelectorAll("[data-monthly-copy]").forEach((copy) => {
    copy.textContent = yearly
      ? copy.dataset.yearlyCopy
      : copy.dataset.monthlyCopy;
  });
}

function setSlidingToggle(toggle, value) {
  const options = toggle.querySelectorAll("[data-pricing-option]");

  toggle.dataset.toggleValue = value;

  options.forEach((option) => {
    const active = option.dataset.pricingOption === value;

    option.classList.toggle("active", active);
    option.setAttribute("aria-pressed", String(active));
  });

  toggle.dispatchEvent(
    new CustomEvent("pricing:change", {
      bubbles: true,
      detail: { value }
    })
  );
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-pricing-toggle]").forEach((toggle) => {
    const pricingPage = toggle.closest(".pricing-page") || document;
    const initialValue = toggle.dataset.toggleValue || "monthly";

    setSlidingToggle(toggle, initialValue);
    updatePrices(pricingPage, initialValue);

    toggle.querySelectorAll("[data-pricing-option]").forEach((option) => {
      option.addEventListener("click", () => {
        const value = option.dataset.pricingOption;

        setSlidingToggle(toggle, value);
        updatePrices(pricingPage, value);
      });
    });

    toggle.addEventListener("keydown", (event) => {
      if (!["ArrowLeft", "ArrowRight"].includes(event.key)) {
        return;
      }

      event.preventDefault();

      const value = event.key === "ArrowRight"
        ? "yearly"
        : "monthly";

      setSlidingToggle(toggle, value);
      updatePrices(pricingPage, value);

      toggle
        .querySelector(`[data-pricing-option="${value}"]`)
        ?.focus();
    });
  });
});
